import log from 'salvo-lite/log'

class YotpoSignUp {
    constructor (theme, elem) {
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const validateEmail = this._validateEmail

        if (this._elem.tagName === 'DIV') {
            window.addEventListener('klaviyoForms', function (e) {
                if (e.detail.type === 'submit') {
                    var email = document.querySelector('.klaviyo-form input[name="email"]').value || ''
                    if (email !== '' && validateEmail(email)) {
                        window.swellAPI.captureNewsletterSignup(email)
                    }
                }
            })
        } else {
            this._elem.addEventListener('click', e => {
                var email = document.querySelector('[data-yotpo-signup-email]').value || ''
                if (email !== '' && validateEmail(email) && document.querySelector('input[type="checkbox"][name="customer[accepts_marketing]"').checked) {
                    sessionStorage.setItem('yotpoSignUpPoints', email)
                }
            })
        }
    }

    _validateEmail (email) {
        // eslint-disable-next-line
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
    }
}

export default YotpoSignUp



// WEBPACK FOOTER //
// ./src/resources/scripts/components/YotpoSignUp.js